import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { InfoLabel } from '../../../../../common/components';
import FormRow from '../../../../../common/components/FormRow/FormRow';
import SelectMenu from '../../../../../common/components/SelectMenu/SelectMenu';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';

const InsurerForm = ({ handleSubmit, isViewOnly }) => {
  return (
    <SchemeManagementSectionContainer
      title={''}
      subTitle={'Insurer'}
      isViewOnly={isViewOnly}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className="section-item">
          <Col sm={12}>
            <FormRow labelSize={2} fieldSize={4} label={'Insurer'}>
              <Field
                name={'data.relationships.insurer.data.id'}
                optionValuePath={'id'}
                source={'organisations/insurers'}
                component={isViewOnly ? InfoLabel : SelectMenu}
              />
            </FormRow>
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};

export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(InsurerForm);
